import { useMutation } from '@tanstack/react-query';
import { updateUserGoalGroupBy } from 'shared/services/backend-api';
import { GoalGroupBy } from 'shared/types/sorting-mode';

export const useUpdateGoalGroupByMutation = () =>
  useMutation({
    mutationFn: async (groupBy: GoalGroupBy) => updateUserGoalGroupBy(groupBy),
  });
